// extracted by mini-css-extract-plugin
export default {"b-icon-warning":"Overview_style_b-icon-warning__rX+Up","wrapper":"Overview_style_wrapper__C+WL9","rotate":"Overview_style_rotate__vn49J"};